import { render, staticRenderFns } from "./roleManagement.vue?vue&type=template&id=25febdbc&scoped=true&"
import script from "./roleManagement.vue?vue&type=script&lang=js&"
export * from "./roleManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25febdbc",
  null
  
)

export default component.exports